// extracted by mini-css-extract-plugin
export default {"layout":"AppSectionLayout_layout__KR94m","subnav_hide":"AppSectionLayout_subnav_hide__1mzg3","page":"AppSectionLayout_page__I7ysy"};